import PhoneVerificationForm from '@map/components/PhoneVerificationForm';
import { buildApiUrl } from '@map/hooks/baseApi';
import { Typography } from '@mui/material';
import useLocationState from '@shared/hooks/useLocationState';
import useNavigate from '@shared/hooks/useNavigate';
import axios from 'axios';
import { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { guestLinks } from '../../links';
import PublicPage from '../shared/PublicPage';

const ForgotPasswordViaPhone: FC = () => {
  const [username] = useLocationState('username', '');
  const navigate = useNavigate();

  const handleSubmit = useCallback(
    async ({ phoneVerificationCode }: { phoneVerificationCode: string }) => {
      try {
        const { data } = await axios.post(buildApiUrl('password_reset/verify_phone'), {
          phone: username,
          code: phoneVerificationCode,
        });
        if (data.token) {
          navigate(`${guestLinks.resetPassword()}?token=${data.token}`);
        }
      } catch (e) {
        console.warn(e);
      }
    },
    [navigate, username],
  );

  return (
    <PublicPage title={<FormattedMessage id="forgot_password.title" />}>
      <PhoneVerificationForm onSubmit={handleSubmit} phone={username} scope="password_reset">
        <Typography variant="body2" align="center">
          <FormattedMessage id="password_reset.sms_sent" tagName="p" />
          <FormattedMessage id="password_reset.sms_instructions" tagName="p" />
        </Typography>
      </PhoneVerificationForm>
    </PublicPage>
  );
};

export default ForgotPasswordViaPhone;
